import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#fafafa]">
      {/* Header */}
      <div className="bg-[#1a2332] text-white py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm mb-6 md:mb-8 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            {t("legal.backHome")}
          </Link>
          <p className="text-xs text-white/40 tracking-[0.3em] uppercase mb-3">LEGAL</p>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-black">{t("footer.privacy")}</h1>
          <p className="text-sm text-white/40 mt-3">{t("legal.lastUpdated")}: 2026年4月4日</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-10 py-10 md:py-20">
        <div className="bg-white rounded-2xl border border-gray-100 p-5 sm:p-8 md:p-12 space-y-8 md:space-y-10 text-sm text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">1. 個人情報の取得について</h2>
            <p>GlobalBridge Japan株式会社（以下「当社」）は、海外メーカーのお客様・パートナー企業様からのお問い合わせ、資料請求、代理店契約のご相談、その他サービスのご利用に際して、氏名、会社名、役職、メールアドレス、電話番号、住所等の個人情報を取得することがあります。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">2. 個人情報の利用目的</h2>
            <p>取得した個人情報は、以下の目的のために利用します。</p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600">
              <li>お問い合わせへの回答・対応</li>
              <li>代理店契約・パートナーシップに関する情報提供</li>
              <li>日本市場参入支援サービスに関するご案内</li>
              <li>契約の締結・履行</li>
              <li>マーケティング・市場調査（同意を得た場合）</li>
              <li>法令に基づく対応</li>
              <li>その他、上記に付随する業務</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">3. 個人情報の第三者提供</h2>
            <p>当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。</p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-gray-600">
              <li>お客様の同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>人の生命・身体・財産の保護のために必要な場合</li>
              <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">4. 個人情報の安全管理</h2>
            <p>当社は、個人情報の漏洩、滅失、毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業員に対して、必要かつ適切な監督を行います。海外メーカーとの取引において取得した情報についても、同等の安全管理措置を適用します。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">5. 越境データ移転について</h2>
            <p>当社は海外メーカーとのビジネスを行う性質上、業務遂行のために個人情報を海外に移転する場合があります。その際は、移転先の国・地域の個人情報保護法制を確認し、適切な保護措置を講じた上で移転を行います。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">6. Cookieの使用について</h2>
            <p>当社のウェブサイトでは、サービスの向上・アクセス解析を目的としてCookieを使用することがあります。Cookieの使用を希望されない場合は、ブラウザの設定によりCookieを無効にすることができます。なお、Cookieを無効にした場合、一部のサービスが正常に機能しない場合があります。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">7. 個人情報の開示・訂正・削除</h2>
            <p>お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除を請求することができます。ご請求の際は、下記お問い合わせ先までご連絡ください。本人確認のうえ、合理的な期間内に対応いたします。</p>
          </section>

          <section>
            <h2 className="text-base md:text-lg font-bold text-[#1a2332] mb-3 md:mb-4">8. プライバシーポリシーの変更</h2>
            <p>当社は、法令の変更や業務内容の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。</p>
          </section>

        </div>
      </div>
    </div>
  );
}
